import React, { useEffect, useState } from "react";
import styles from "../TriggerField.module.scss";
import { TextField } from "@mui/material";
import { CustomDropdown } from "components/shared/customDropdown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useDispatch, useSelector } from "react-redux";
import { setDroppedItems } from "@redux/slices/triggerSlice";
import { emailRegex } from "utils/regex";
import { setPublish } from "@redux/slices/globalSlice";

const optionsArray = [
    { label: "contain", value: "contain" },
    { label: "is", value: "is" },
    { label: "does not contain", value: "does not contain" },
    { label: "is answered", value: "is answered" },
    { label: "is unanswered", value: "is unanswered" },
];
const EmailTrigger = ({ item }) => {
    const { triggerDroppedList } = useSelector((state) => state?.trigger);
    const [localOptions, setLocalOptions] = useState(item?.trigger || { label: "Email", options: item?.operator || "contain", value: item?.value || [] });
    const dispatch = useDispatch();
    const handleChange = (name, value, validate) => {
        setLocalOptions((prev) => {
            let updatedOptions = {
                ...prev, [name]: value,
            };
            if (validate) {
                if (emailRegex.test(value)) {
                    delete updatedOptions.isError; 
                } else {
                    updatedOptions.isError = true; 
                }
            }
            if (name === "options") {
                if (value === "is unanswered" || value === "is answered") {
                    updatedOptions = {
                        ...updatedOptions,
                        value: "",
                    };

                }
            }
            return updatedOptions;
        });
    };
    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id);
        dispatch(setDroppedItems(filteredDroppedItems));
        dispatch(setPublish(true))
    };

    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) => {
            if (e?.id === item?.id) {
                return {
                    ...e,
                    optionLabel: item?.label || "Email", 
                    trigger: { ...localOptions },
                };
            }
            return e;
        });
        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);

    useEffect(() => {
        setLocalOptions((prev) => ({
            ...prev,
            options: item?.operator || prev.options,
            ...(item?.value ? {
                value: item?.value
            } : {}),
        }));
    }, [item?.operator, item?.value]);

    return (
        <div className={styles?.metaContainer}>
            <div className={styles?.field}>
                <TextField value={item?.label || "Email"} disabled name="label" />

                <CustomDropdown
                    width='200px'
                    name="options"
                    options={optionsArray}
                    value={localOptions?.options || ""}
                    onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                />
                {
                    localOptions?.options == "is unanswered" || localOptions?.options == "is answered" ?
                        null
                        :
                        <TextField
                            name="value"
                            value={localOptions?.value || ""}
                            onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                            onBlur={(e) => handleChange(e?.target?.name, e?.target?.value, true)}
                            error={localOptions?.options==="is" && localOptions?.isError}
                            helperText={localOptions?.options==="is" && localOptions?.isError ? "Invalid Email" : ""}
                        />
                }
            </div>
            <div
                className={styles.iconClose}
                onClick={handleDelete}
            >
                <HighlightOffIcon />
            </div>
        </div>
    );
};

export default EmailTrigger;
